module.exports = "//static.hsappstatic.net/growth-data-modal/static-1.2618/images/outlook-exchange-contacts.svg"